import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-icon-warning-triangle-bold',
    templateUrl: './icon-warning-triangle-bold.component.html',
    styleUrls: ['./icon-warning-triangle-bold.component.css'],
    standalone: true,
})
export class IconWarningTriangleBoldComponent {
  @Input() color = '#b91c1c';
  @Input() width = '24';
  @Input() height = '24';
}
